import { render, staticRenderFns } from "./StatusButton.vue?vue&type=template&id=aa9464c6&"
import script from "./StatusButton.vue?vue&type=script&lang=js&"
export * from "./StatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports